import React from 'react';
import { Box, InputAdornment, TextField } from 'components/mui';
import { SearchIcon, CloseOutlinedIcon } from 'components/icons';

interface CaseSearchProps {
  searchInput: string;
  onSearchInput: (input: string) => void;
  onReset: () => void;
}

function CaseSearch({ searchInput, onSearchInput, onReset }: CaseSearchProps) {
  const handleClear = () => {
    onSearchInput('');
    onReset();
  };

  return (
    <TextField
      size="small"
      placeholder="Search cases..."
      value={searchInput}
      onChange={(e) => onSearchInput(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
          </InputAdornment>
        ),
        endAdornment: searchInput ? (
          <InputAdornment position="end">
            <Box
              component="button"
              onClick={handleClear}
              sx={{
                border: 'none',
                background: 'none',
                cursor: 'pointer',
                p: 0.25,
                display: 'flex',
                color: 'text.secondary',
                '&:hover': { color: 'text.primary' },
              }}
              aria-label="Clear search"
            >
              <CloseOutlinedIcon sx={{ fontSize: 16 }} />
            </Box>
          </InputAdornment>
        ) : null,
      }}
      sx={{
        flex: 1,
        minWidth: 200,
        '& .MuiOutlinedInput-root': { bgcolor: 'background.paper' },
      }}
    />
  );
}

export default CaseSearch;
